export const nullIsland = [0, 0];
//# sourceMappingURL=coordinate.js.map